/** Known equivalents of legacy CMS URLs. Unknown products retain their 404. */
export function normalizeLegacyContentPath(value: string): string {
    let url: URL;
    try { url = new URL(value, 'https://ur-met.ru'); }
    catch { return value; }
    if (!['ur-met.ru', 'www.ur-met.ru'].includes(url.hostname)) return value;
    let path = url.pathname;
    let region = path.match(/^\/geo\/(msk|spb)(?=\/)/)?.[0] || '';
    if (region) path = path.slice(region.length);
    path = path.replace(/\/+$/, '') || '/';
    const originalPath = path;
    const aliases: Record<string, string> = {
        '/proizvodstvo-metallokonstruktsiy-i-izdeliy': '/shop/category/metallokonstruktsii',
        '/proizvodstvo-metallokonstruktsiy-i-izdeliy/proizvodstvo': '/shop/',
        '/about': '/pages/o-kompanii',
        '/company': '/pages/o-kompanii',
        '/kontakty': '/company/contacts',
        '/izgotovlenie-metallokonstruktsiy/kontakty': '/company/contacts',
        '/legal/user-agreement': '/pages/user-agreement',
        '/politika-konfidentsialnosti': '/pages/politika-konfidentsialnosti-personalnykh-dannykh',
        '/legal/politika-konfidentsialnosti': '/pages/politika-konfidentsialnosti-personalnykh-dannykh',
        '/metalloprokat': '/shop/category/metalloprokat',
        '/metalloprokat/chernyj-metalloprokat': '/shop/category/chernyy-metalloprokat',
        '/metalloprokat/nerzhaveyushhij-metalloprokat': '/shop/category/nerzhaveyushchiy-metalloprokat',
        '/chernyj-metalloprokat/aramtura': '/shop/category/armatura',
        '/izgotovlenie-metallokonstruktsiy': '/shop/category/metallokonstruktsii',
        '/izgotovlenie-metallokonstruktsiy/vidy-stroitelnykh-rabot': '/shop/category/stroitelnye-raboty',
        '/izgotovlenie-metallokonstruktsiy/bystrovozvodimye-zdaniya': '/shop/category/bystrovozvodimye-zdaniya-iz-metallokonstruktsiy',
        '/careers': '/pages/vakansii',
        '/calculator': '/raschet-zdaniya',
        '/(spb)/company/legal/cookies': '/pages/politika-konfidentsialnosti',
        '/(spb)/company/legal/politika-konfidentsialnosti': '/pages/politika-konfidentsialnosti',
        '/company/legal/politika-konfidentsialnosti': '/pages/politika-konfidentsialnosti',
        '/shop/item/rezka-rubka-lista': '/shop/item/rezka-rubka-listov',
        '/blog/svarnye-dvutavrovye-balki': '/blog/svarnye-dvutavrovye-balki-proizvodstvo-tiporazmery-i-primenenie',
        '/shop/item/vozdukhovody-gazokhody-s-tolstoy-stenkoy': '/shop/item/dymokhody-vozdukhovody-gazokhody-koroba-dlya-dymoudaleniya-truby-s-tolshchinoy-stenki-3mm-4mm-5mm',
    };
    path = path.replace(/^\/proizvodstvo-metallokonstruktsiy-i-izdeliy\/proizvodstvo\/(.+)$/, '/shop/item/$1')
        .replace(/^\/izgotovlenie-metallokonstruktsiy\/vidy-stroitelnykh-rabot\/(.+)$/, '/shop/item/$1')
        .replace(/^(\/(?:shop\/category|blog)\/[^/]+)\/preload$/, '$1');
    path = aliases[path] || path;
    if (['/pages/o-kompanii', '/company/contacts', '/pages/user-agreement', '/pages/politika-konfidentsialnosti-personalnykh-dannykh', '/pages/vakansii', '/raschet-zdaniya', '/pages/politika-konfidentsialnosti'].includes(path)) {
        if (originalPath === '/calculator' && region) url.searchParams.set('branch', region.split('/').pop() || 'spb');
        region = '';
    }
    if (path === originalPath) return value;
    return `${region}${path === '/' ? '/' : path.replace(/\/+$/, '') + '/'}${url.search}${url.hash}`;
}

export function rewriteLegacyHtmlLinks(html: string): string {
    return html.replace(/(<a\b[^>]*?\bhref\s*=\s*)(["'])(.*?)\2/gi, (_match, prefix, quote, href) => {
        const normalized = normalizeLegacyContentPath(href.replace(/&amp;/g, '&'));
        return `${prefix}${quote}${normalized.replace(/&/g, '&amp;')}${quote}`;
    });
}
